// extracted by mini-css-extract-plugin
export default {"masterContainer":"ScreenLoading_masterContainer__ZFeKL","loadingContainer":"ScreenLoading_loadingContainer__inUax"};